import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Stream from 'flarum/common/utils/Stream';

// Must match FoF\AntiSpam\Honeypot::FIELD and ::TOKEN.
const FIELD = 'fof_as_comment';
const TOKEN = 'fof_as_token';

// SignUpModal is a lazy-loaded chunk, so it is extended by path: the patch applies when it loads.
// Extending the imported class would patch nothing, as the class is not there yet.
const MODAL = 'flarum/forum/components/SignUpModal';

/**
 * Adds the honeypot to the sign-up form: a field moved off-screen and hidden from assistive
 * technology, which only a bot filling in every input fills, and the signed timestamp the page
 * was served with. The forum only hands out a token while the honeypot is on.
 */
export default function addHoneypot() {
  extend(MODAL, 'oninit', function () {
    this.fofAntiSpamTrap = Stream('');
  });
  extend(MODAL, 'fields', function (items) {
    if (!app.forum.attribute('fof-anti-spam.formToken')) return;

    // Off-screen rather than display:none, which some bots know to skip.
    items.add('fofAntiSpamTrap', m("div", {
      className: "FoFAntiSpam-trap",
      "aria-hidden": "true",
      inert: true
    }, m("label", null, app.translator.trans('fof-anti-spam.forum.sign_up.trap_label'), m("input", {
      className: "FormControl",
      type: "text",
      name: FIELD,
      tabindex: -1,
      autocomplete: "off",
      bidi: this.fofAntiSpamTrap
    }))), -100);
  });
  extend(MODAL, 'submitData', function (data) {
    const token = app.forum.attribute('fof-anti-spam.formToken');
    if (!token) return;
    Object.assign(data, {
      [FIELD]: this.fofAntiSpamTrap(),
      [TOKEN]: token
    });
  });
}
flarum.reg.add('fof-anti-spam', 'forum/extenders/addHoneypot', addHoneypot);